import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  AccountClient,
  SAVE_PERSONALIZATION,
  GET_ENTITY_PROPERTIES,
  GET_TICKET_LISTVIEW_META,
  GET_PERSONALIZATION_BY_NAME
} from '@nile/graphql';
import {
  getTranslatedText,
  AppContext,
  toast,
  EventEmitter,
  getCurrentUserHook,
  useCurrentServicePortal,
  COMMON_CONSTANTS
} from '@nile/components';
import ViewSheet from '@nile/mangifera/src/Components/Sheets/ViewSheet';
import { ADD_TICKET_VIEW } from '@nile/mangifera/src/Graphql/Mutations/ticketview';
import React, { useCallback, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { TicketContext } from '@nile/mangifera/src/Contexts';
import { injectIntl } from 'react-intl';

const VIEWS = {
  TASK: 'task',
  TICKET: 'ticket',
  PROJECT: 'project'
};

function NewViewType(props) {
  const { intl } = props;
  const context = useContext(TicketContext);
  const appContext = useContext(AppContext);
  const [savePersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient,
    onCompleted({ savePersonalization }) {
      if (savePersonalization) {
        toast('success', 'ticket.view.viewCreation.success');
      }
    },
    onError() {
      // toast('error', 'Something went wrong');
    }
  });
  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useQuery(GET_ENTITY_PROPERTIES, { client: AccountClient });
  const {
    loading: ticketListViewMetaLoading,
    error: ticketAutomationError,
    data: ticketListViewMeta
  } = useQuery(GET_TICKET_LISTVIEW_META, {
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });

  const [personalization, setPersonalization] = useState({});

  const [addTicketView] = useMutation(ADD_TICKET_VIEW, {
    onCompleted({ addTicketView }) {
      /* Close sheet container once an employee created */
      if (addTicketView) {
        // personalization.name =  addTicketView.id
        // savePersonalization({
        //   variables: personalization,
        //   input: personalization,
        // });
        // const { user, category,  name, value } = personalization
        // savePersonalization({
        //   variables: { user, category, name, value },
        //   input: {
        //     user: user,
        //     category: category,
        //     name: name,
        //     value: value
        //   },
        // });
        // toggleActive()
        window.setTimeout(() => {
          //props.history.goBack();
        }, 1000); // eslint-disable-line
      }
    },
    update(cache, { data }) {},
    onError() {
      // toast('error', 'Something went wrong');
    }
  });

  const user = getCurrentUserHook();
  const manageViewCategoryName = useCurrentServicePortal('workspace');

  const {
    data: personalizedData,
    loading: personalizationLoading,
    refetch: getPersonilizationByName
  } = useQuery(GET_PERSONALIZATION_BY_NAME, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    variables: {
      userId: user.userId,
      category: manageViewCategoryName,
      name: 'ManageViews'
    }
  });

  const [
    mutateSidebarPersonalization,
    { loading: personalizationMutationLoading }
  ] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient,
    onCompleted() {}
  });

  const saveSidebarCustomisation = useCallback(
    (value) => {
      return mutateSidebarPersonalization({
        variables: {
          name: 'ManageViews',
          category: manageViewCategoryName,
          user: {
            firstName: user?.firstName,
            userId: user?.userId,
            email: user?.email,
            lastName: user?.lastName
          },
          value: JSON.stringify(value)
        }
      });
    },
    [user, mutateSidebarPersonalization, manageViewCategoryName]
  );

  const back = useCallback(() => {
    context.closeTab();
  }, []); // eslint-disable-line

  function addNewTicketView(...args) {
    return addTicketView(...args).then((res) => {
      const id = res.data.addTicketView?.id;
      return getPersonilizationByName().then(({ data }) => {
        if (data.getPersonalizationByCategoryAndName) {
          let leftNavPersonalization = null;
          if (
            data.getPersonalizationByCategoryAndName?.value &&
            data.getPersonalizationByCategoryAndName?.value !== 'null'
          ) {
            leftNavPersonalization = JSON.parse(
              data.getPersonalizationByCategoryAndName.value
            );

            leftNavPersonalization[VIEWS.TICKET].list = [
              id,
              ...leftNavPersonalization[VIEWS.TICKET].list
            ];
            saveSidebarCustomisation(leftNavPersonalization);
          }
        }
        return res;
      });
    });
  }

  const actions = {
    primaryAction: addNewTicketView,
    savePersonalization: savePersonalization,
    back: back
  };
  if (entitiesLoading || ticketListViewMetaLoading)
    return <div>loading...</div>;
  const ticketAttributes = allEntities?.getEntitiesMeta.find((item) => {
    return item.name === 'Ticket';
  }).attributes;
  const defaultSelectedColumns = ticketListViewMeta?.getTicketListViewMetaInfo?.defaultSelectedAttributes.map(
    (el) => {
      const selectedAttr = ticketAttributes.find((attr) => attr.name === el);
      return {
        ...selectedAttr,
        id: selectedAttr.name,
        label: getTranslatedText(intl, selectedAttr.label)
      };
    }
  );
  return (
    <React.Fragment>
      <ViewSheet
        defaultSelectedColumns={defaultSelectedColumns}
        addTicketView={addTicketView}
        actions={actions}
        appContext={appContext}
        context={context}
        entityShareKey={'addEntityShare'}
      />
    </React.Fragment>
  );
}

export default injectIntl(withRouter(NewViewType));
